import { Badge, type BadgeStyleMap } from './Badge';
import { getSubmissionTypeLabel } from '../../utils/submissionType';

const SUBMISSION_STATUS_LABELS: Record<string, string> = {
  resolved: 'Resolved',
  submitted: 'Submitted',
  'in review': 'In Review',
  pending: 'Pending',
  closed: 'Closed',
};

const SUBMISSION_STATUS_STYLES: BadgeStyleMap = {
  Resolved: { color: '#16a34a', bg: '#f0fdf4' },
  Submitted: { color: '#ca8a04', bg: '#fefce8' },
  'In Review': { color: '#ca8a04', bg: '#fefce8' },
  Pending: { color: '#2563eb', bg: '#eff6ff' },
  Closed: { color: '#6b7280', bg: '#f9fafb' },
};

export function SubmissionStatusBadge({ status }: { status?: string }) {
  const label = SUBMISSION_STATUS_LABELS[(status || '').toLowerCase()] || status;
  return <Badge value={label} styleMap={SUBMISSION_STATUS_STYLES} />;
}

const COMPLAINT_STYLE = { color: '#C73838', bg: '#fef2f2' };
const REQUEST_STYLE = { color: '#2563eb', bg: '#eff6ff' };

export function SubmissionTypeBadge({ type }: { type?: string }) {
  const isComplaint = (type || '').toLowerCase() === 'complaint';
  const label = getSubmissionTypeLabel(type || '');
  return (
    <Badge
      value={label}
      styleMap={{ [label]: isComplaint ? COMPLAINT_STYLE : REQUEST_STYLE }}
      dot
    />
  );
}
